import { Routes } from '@angular/router';
import { NotfoundComponent } from './components/notfound/notfound.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { MapComponent } from './components/map/map.component';
import { ContactInfoComponent } from './components/contact-info/contact-info.component';



export const routes: Routes = [

    {
        path: '',
        component: MapComponent,
        pathMatch: 'full'
    },
    {
        path: 'map',
        component: MapComponent
    },
    {
        path: 'location',
        component: MapComponent,
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
    },
    {
        path: 'privacypolicy',
        component: PrivacyPolicyComponent,
    },
    {
        path: 'contact',
        component: ContactInfoComponent,
    },
    // Wildcard route should always be last
    {
        path: '**',
        component: NotfoundComponent,
    },
];